// Librerías externas
const Bloodhound = require('typeahead.js/dist/bloodhound');
require('typeahead.js/dist/typeahead.jquery');

// Librerías propias
import "./select2.js";

let lastSearch;
let lastPublisher;
let lastSubject;
let lastLanguage;

$(function () {
    // Inicializa el buscador simple del navbar
    initSimpleNavbarSearcher();
    // Inicializa los filtros del buscador avanzado del navbar
    initAdvancedNavbarSearcherFilters('publisher');
    initAdvancedNavbarSearcherFilters('subject');
    initAdvancedNavbarSearcherFilters('language');
});

/**
 * Initialize the searcher
 */
function initSimpleNavbarSearcher() {
    $(document).on(
        'keypress click',
        '#navbarSearchFormInputSearch, #navbarSearchFormButtonSearch',
        function (event) {
            if (
                (event.currentTarget.localName === 'input' &&
                    event.type === 'keypress' &&
                    event.which === 13) ||
                (event.currentTarget.localName === 'button' &&
                    event.type === 'click')
            ) {
                if (!$('form#navbarSearchForm')[0].checkValidity()) {
                    $("<input type=\"submit\">")
                        .hide()
                        .appendTo('#navbarSearchForm')
                        .click()
                        .remove();
                } else {
                    event.preventDefault();
                    cleanStoragedFacetsFilter();
                    window.location = `${urlSearch}/${encodeURIComponent($('#navbarSearchFormInputSearch').val())}`;
                }
            }
        }
    );

    // Typeahead búsqueda de artículo
    // Instantiate the bloodhound suggestion engine
    let ttaSearchArticles = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('idarticulo'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        // limit: 31,
        remote: {
            url:     urlGetSearchForTypeahead,
            prepare: function (query, settings) {
                settings.type        = 'POST';
                settings.contentType = 'application/json; charset=UTF-8';
                settings.data        = JSON.stringify({
                    // Establezco los parámetros a obtener en la consulta
                    search:         query,
                    selectFields:   [
                        'idarticulo',
                        'descripcion',
                        'autor',
                        'ean',
                        'precio',
                        'pvp',
                        'precio_libre'
                    ],
                    resultsPerPage: 30,
                });
                settings.beforeSend  = function (e) {
                    if (lastSearch) {
                        lastSearch.abort();
                    }
                    lastSearch = e;
                };
                return settings;
            },
            filter:  function (list) {
                window.totalNavbarSearchResults = list[list.length - 1];
                return list;
            },
            ttl:     false,
        },
    });
    // Initialize the bloodhound suggestion engine
    ttaSearchArticles.initialize();
    // Instantiate the typeahead UI
    $('#navbarSearchFormInputSearch')
        .typeahead(
            {
                hint:      true,
                minLength: 3,
                highlight: true,
            },
            {
                name:       'SearchArticles',
                displayKey: 'descripcion',
                // Se pone el límite +1 para indicar el elemento extra con el contador
                limit:     30,
                source:    throttle(ttaSearchArticles.ttAdapter(), 500),
                templates: {
                    header: function (context) {
                        // Pintamos el último elemento devuelto en el array de urlGetSearch
                        return `<div style="height: 25px; margin-left: 5px; padding-top: 0px;">
                                    <strong>${trans('Coincidences')}: <span class="text-secondary">${totalNavbarSearchResults}</span></strong>
                                </div>`;
                    },
                    // Mensaje de carga
                    notFound:   function (event) {
                        return `<div class="col-12 text-center p-3">
                                    <h5>
                                        <i class="fas fa-spinner fa-pulse mr-1"></i>${trans('Searching...')}
                                    </h5>
                                </div>`;
                    },
                    suggestion: function (article) {
                        // Check if the article is zero
                        if (article === 0) {
                            // Return the 'no results' option

                            const newBook = "".concat(urlSearch, "/").concat(encodeURIComponent($('#navbarSearchFormInputSearch').val()));

                            return `<div class="col-12 text-center text-danger p-3">
                                        <h5>
                                            <i class="fas fa-exclamation-triangle mr-1"></i>${trans('There are no results that match the selected filter!')}
                                            ${typeof authUser !== "undefined" ?
                                              `<br><br>
                                            <a onclick="window.location.assign('${newBook}')">${trans('If you want a book that does not appear on our website, click here and fill the form')}</a>` : ``
                            }
                                        </h5>
                                    </div>`;
                        }

                        // Check if the product is undefined
                        if (typeof article.idarticulo === "undefined") {
                            // Return an empty div
                            return '<div></div>';
                        }

                        // Suggestion
                        let sugestion = `<div class="articleSuggestion">
                                            <div class="articleSuggestionContainerImage">
                                                <img class="articleSuggestionImage" src="${appEnv !== 'production' ? urlArticleImageNotFound : urlArticleImage + article.ean.substr(0, 7) + '/' + article.ean.substr(0, 12) + articleImageExtension}" onerror="this.onerror=null;this.src='${urlArticleImageNotFound}';" alt="${article.descripcion}">
                                            </div>
                                            <div class="articleSuggestionContent">
                                                <div class="articleSuggestionHeader">
                                                    <span class="articleSuggestionTitle">${article.descripcion}</span>`;


                        if (typeof authUser !== 'undefined') {
                            sugestion = sugestion + `<span class="articleSuggestionPrice">${parseFloat(article.precio).toFixed(2).replace('.', ',')} € <small class="badge badge-danger" style="vertical-align: top;">${trans('Tax excluded')}</small></span>`;

                        }


                        sugestion = sugestion + `
                                        </div>
                                        <div class="articleSuggestionBody">
                                            <span class="articleSuggestionEan">${article.ean}</span>
                                            <span class="articleSuggestionAuthor">${article.autor !== null ? article.autor : '&nbsp;'}</span>
                                        </div>
                                    </div>
                                </div>`;
                        return sugestion;
                    },
                },
            }
        )
        .on('typeahead:select', function (obj, datum) {
            // $(obj.target).change();
            // Redirect to the article
            window.location = `${urlArticle}/${datum.idarticulo}`;
        })
        .on('typeahead:open', function (obj) {
            $('.tt-menu').addClass('col');
        });
    $('.twitter-typeahead').addClass('form-control');
}

/**
 * Initialize the advanced search filters
 */
window.initAdvancedNavbarSearcherFilters = function (field = '') {
    $(`#navbarAdvancedSearchFormInput${pascalCase(field)}`).select2({
        language:           'es',
        theme:              'bootstrap4',
        width:              'resolve',
        minimumInputLength: 0,
        allowClear:         true,
        ajax:               {
            url:            eval(`apiGet${pascalCase(field)}s`),
            type:           'POST',
            dataType:       'json',
            delay:          250, // wait 250 milliseconds before triggering the request
            data:           function (params) {
                // Query parameters will be ?search=[term]&type=public
                let data = {
                    count:          1,
                    resultsPerPage: 10,
                    currentPage:    params.page || 1,
                    orderBy:        ['title'],
                    orderDir:       ['asc'],
                }

                if (field === 'publisher') {
                    // data.showThirds = 1;
                    data.whereHas = {
                        thirds: {
                            searchFields: {
                                title: params.term,
                            },
                            conditions:   {
                                title: 'like',
                            },
                        },
                    }
                } else {
                    data.searchFields = {
                        title: params.term,
                    };
                    data.conditions   = {
                        title: 'like',
                    };
                }

                return data;
            },
            processResults: function (data, params) {
                params.page = params.page || 1;

                // Transform the results into the format expected by Select2.
                let results = [];

                data.list.forEach(function (item) {
                    results.push({
                        // id:   item.id,
                        id:   item.title,
                        text: item.title,
                    });
                });

                // Transforms the top-level key of the response object from 'items' to 'results'
                return {
                    results:    results,
                    pagination: {
                        more: (params.page * 10) < data.numFound
                    }
                };
            },
        },
        // templateResult: formatRepo,
        // templateSelection: formatRepoSelection
    });
}

// window.initAdvancedNavbarSearcherFilters = function (field = '', resultField = '') {
//     /** Typeahead búsqueda de entidad ***/
//     let ttaSearchCartNewLineArticles = new Bloodhound({
//         datumTokenizer: Bloodhound.tokenizers.obj.whitespace("id"),
//         queryTokenizer: Bloodhound.tokenizers.whitespace,
//         // limit: 31,
//         remote: {
//             // url: `${urlGlobal}/api/${urlGetField}/find`,
//             // url: urlGetSearchForTypeahead,
//             url:     `${urlHome}/${field}s/get-for-typeahead`,
//             prepare: function (query, settings) {
//                 settings.type        = 'POST';
//                 settings.contentType = 'application/json; charset=UTF-8';
//                 settings.data        = JSON.stringify({
//                     // Establezco los parámetros a obtener en la consulta
//                     selectFields:   [resultField],
//                     title:          query,
//                     resultsPerPage: 30,
//                 });
//                 settings.beforeSend  = function (e) {
//                     if (window['last' + pascalCase(field)]) {
//                         window['last' + pascalCase(field)].abort();
//                     }
//                     window['last' + pascalCase(field)] = e;
//                 };
//                 return settings;
//             },
//             filter:  function (list) {
//                 return list;
//             },
//             ttl:     false,
//         },
//     });
//     // Initialize the bloodhound suggestion engine
//     ttaSearchCartNewLineArticles.initialize();
//     // Instantiate the typeahead UI
//     $(`#navbarAdvancedSearchFormInput${pascalCase(field)}`)
//         .typeahead(
//             {
//                 hint:      true,
//                 minLength: 3,
//                 highlight: true,
//             },
//             {
//                 name:       `Search${pascalCase(field)}s`,
//                 displayKey: resultField,
//                 // Se pone el límite +1 para indicar el elemento extra con el contador
//                 limit:     30,
//                 source:    throttle(ttaSearchCartNewLineArticles.ttAdapter(), 500),
//                 templates: {
//                     // Mensaje de carga
//                     notFound:   function (event) {
//                         return `<div class="col-12 text-center p-1">
//                                     <span>
//                                         <i class="fas fa-spinner fa-pulse mr-1"></i>${trans('Searching...')}
//                                     </span>
//                                 </div>`;
//                     },
//                     suggestion: function (item) {
//                         // Check if the field is zero
//                         if (item === 0) {
//                             // Return the 'no results' option
//                             return `<div class="col-12 text-center text-danger p-1">
//                                 <span>
//                                     <i class="fas fa-exclamation-triangle mr-1"></i>${trans('There are no results that match the selected filter!')}
//                                 </span>
//                             </div>`;
//                         }
//
//                         // Check if the item is undefined
//                         if ('undefined' === typeof item[resultField]) {
//                             // Return an empty div
//                             return "<div></div>";
//                         }
//
//                         // Suggestion
//                         return `<div class="itemSuggestion">
//                                     <div class="itemSuggestionContent">
//                                         <div class="itemSuggestionHeader">
//                                             <span class="itemSuggestionTitle">${item[resultField]}</span>
//                                         </div>
//                                     </div>
//                                 </div>`;
//                     },
//                 },
//             }
//         )
//         .on("typeahead:select", function (obj, datum) {
//             // $(obj.target).change();
//             // $(obj.target).val(datum.title);
//         })
//         .on("typeahead:open", function (obj) {
//             $('.tt-menu').addClass('col');
//         });
//     $('.twitter-typeahead').addClass('form-control');
// }

/**
 * Clean Navbar Advanced Search Filters
 */
window.cleanNavbarAdvancedSearchFiltersForm = function () {
    $('#navbarAdvancedSearchFormInputTitle, #navbarAdvancedSearchFormInputAuthor, #navbarAdvancedSearchFormInputPublisher, #navbarAdvancedSearchFormInputSubject, #navbarAdvancedSearchFormInputLanguage, #navbarAdvancedSearchFormInputCollection').val('').change();
}

/**
 * Submit Navbar Advanced Search Form
 */
window.submitNavbarAdvancedSearchForm = function () {
    event.preventDefault();
    cleanStoragedFacetsFilter();
    let urlParams = '';
    if ($('#navbarAdvancedSearchFormInputTitle').val().length) {
        urlParams = encodeURIComponent($('#navbarAdvancedSearchFormInputTitle').val());
    } else {
        urlParams = '*';
    }
    if ($("#navbarAdvancedSearchFormInputAuthor").val().length) {
        addStoragedFacetFilter('Author', $('#navbarAdvancedSearchFormInputAuthor').val());
    }
    if ($("#navbarAdvancedSearchFormInputPublisher").val() !== null) {
        addStoragedFacetFilter('Publisher', $('#navbarAdvancedSearchFormInputPublisher').val());
    }
    if ($("#navbarAdvancedSearchFormInputCollection").val().length) {
        addStoragedFacetFilter('collectionTitle', $('#navbarAdvancedSearchFormInputCollection').val());
    }
    if ($("#navbarAdvancedSearchFormInputSubject").val() !== null) {
        addStoragedFacetFilter('Subject', $('#navbarAdvancedSearchFormInputSubject').val());
    }
    if ($("#navbarAdvancedSearchFormInputLanguage").val() !== null) {
        addStoragedFacetFilter('Language', $('#navbarAdvancedSearchFormInputLanguage').val());
    }
    window.location = `${urlSearch}/${urlParams}`;
}